import { ProfiloVO } from "@app/shared/vo/profiloVO";
import { StrutturaVO } from "./strutturaVO";

export class UtenteVO {
  username: string;
  nome: string;
  isSmistatoreArea: boolean;
  cognome: string;
  id: string;
  profili: ProfiloVO[];
  isEstensore: boolean;
  isEstensoreLiquidazione: boolean;
  isConsultatore: boolean;
  isResponsabile: boolean;
  isRedattore: boolean;
  isVerificatore: boolean;
  isCollegio: boolean;
  isVerificatoreContabile: boolean;
  isSegreteria: boolean;
  isAssegnato: boolean;
  check: boolean;
  strutturaAppartenenza: StrutturaVO;
  token: string;

}
